import TaskTypeFormElementDTO from './taskTypeFormElementDTO';
import { TaskType_TranslationDTO } from './taskType_TranslationDTO';

export default class TaskTypeDTO {
  taskTypeId: number;

  taskTypeFamilyId?: number;

  version: number;

  definitionHash?: string;

  firstUsedOn?: string;

  lastAmendedOn?: string;

  rowVersion?: string;

  isArchived: boolean;

  authSchemaId?: number;

  systemTaskType?: number;

  isSystem: boolean;

  // Create only: the form belongs to the thing that owns it (an audit procedure) instead of to the
  // organisation's form catalogue, so it is never offered where a form is picked.
  isHidden?: boolean;

  trans: TaskType_TranslationDTO[];

  transIdx: number;

  name: string;

  description?: string;

  form?: TaskTypeFormElementDTO[];

  constructor() {
    this.taskTypeId = 0;
    this.trans = [];
    this.name = '';
    this.transIdx = -1;
    this.isSystem = false;
    this.version = 0;
    this.isArchived = false;
  }
}
